/**
 * Verificación de email — helpers de sesión + URL de acción Firebase.
 * Exports requeridos por VerificarEmailEmpresa.js y configuracionempresa.js (HEAD).
 */

export const EMAIL_VERIFY_SENT_SESSION_KEY = 'nexopos_email_verify_sent_session';

export function markEmailVerificationSentInSession() {
  try {
    sessionStorage.setItem(EMAIL_VERIFY_SENT_SESSION_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function hasEmailVerificationBeenSentThisSession() {
  try {
    return sessionStorage.getItem(EMAIL_VERIFY_SENT_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearEmailVerificationSessionFlag() {
  try {
    sessionStorage.removeItem(EMAIL_VERIFY_SENT_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * Configuración del enlace que Firebase incluye en el correo de verificación.
 */
export function getEmailActionCodeSettings() {
  const raw = (process.env.REACT_APP_PUBLIC_APP_URL || 'https://nexopos-dc.web.app').trim();
  const base = raw.replace(/\/$/, '');
  return {
    handleCodeInApp: false,
    url: `${base}/verificar-email`
  };
}
